import React from 'react';
import PropTypes from 'prop-types';

import './header-box.css';

const HeaderBox = ({ copy, header, spaceAbove }) => (
    <div className={`header-box ${spaceAbove ? 'space-above' : ''}`}>
        {header && <h2>{header}</h2>}
        {copy && <p>{copy}</p>}
    </div>
);

HeaderBox.defaultProps = {
    spaceAbove: false,
};

HeaderBox.propTypes = {
    copy: PropTypes.string,
    header: PropTypes.string,
    spaceAbove: PropTypes.bool,
};

export default HeaderBox;
